/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalStateEvent
 */
export interface TerminalStateEvent {
    /**
     * 
     * @type {boolean}
     * @memberof TerminalStateEvent
     */
    askForTip: boolean;
    /**
     * 
     * @type {TerminalStateEventLatestStateEnum}
     * @memberof TerminalStateEvent
     */
    latestState: TerminalStateEventLatestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TerminalStateEvent
     */
    pspTerminalId: string;
    /**
     * 
     * @type {number}
     * @memberof TerminalStateEvent
     */
    timestampMs: number;
    /**
     * 
     * @type {string}
     * @memberof TerminalStateEvent
     */
    batteryLevel?: string | null;
    /**
     * 
     * @type {TerminalStateEventLatestEventCodeEnum}
     * @memberof TerminalStateEvent
     */
    latestEventCode?: TerminalStateEventLatestEventCodeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalStateEvent
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalStateEvent
     */
    pspDetails?: string | null;
}


/**
 * @export
 */
export const TerminalStateEventLatestStateEnum = {
    UNKNOWN: 'UNKNOWN',
    OK: 'OK',
    BUSY: 'BUSY',
    MAINTENANCE: 'MAINTENANCE',
    UNREACHABLE: 'UNREACHABLE',
    OUT_OF_ORDER: 'OUT_OF_ORDER'
} as const;
export type TerminalStateEventLatestStateEnum = typeof TerminalStateEventLatestStateEnum[keyof typeof TerminalStateEventLatestStateEnum];

/**
 * @export
 */
export const TerminalStateEventLatestEventCodeEnum = {
    PAYMENT_RESPONSE: 'PAYMENT_RESPONSE',
    SHUTDOWN: 'SHUTDOWN',
    BEGIN_MAINTENANCE: 'BEGIN_MAINTENANCE',
    END_MAINTENANCE: 'END_MAINTENANCE',
    OUT_OF_ORDER: 'OUT_OF_ORDER',
    INITIALISED: 'INITIALISED',
    NETWORK_CONNECTED: 'NETWORK_CONNECTED',
    NETWORK_DISCONNECTED: 'NETWORK_DISCONNECTED',
    REJECT: 'REJECT',
    SALE_WAKE_UP: 'SALE_WAKE_UP',
    COMPLETED: 'COMPLETED',
    ASK_GRATUITY: 'ASK_GRATUITY',
    GRATUITY_ENTERED: 'GRATUITY_ENTERED',
    TENDER_CREATED: 'TENDER_CREATED',
    CARD_PRESENTED: 'CARD_PRESENTED',
    CARD_INSERTED: 'CARD_INSERTED',
    WAIT_FOR_PIN: 'WAIT_FOR_PIN',
    PIN_ENTERED: 'PIN_ENTERED',
    CARD_REMOVED: 'CARD_REMOVED',
    CARD_SWIPED: 'CARD_SWIPED',
    PRINT_RECEIPT: 'PRINT_RECEIPT',
    TENDER_FINAL: 'TENDER_FINAL',
    WAIT_FOR_APP_SELECTION: 'WAIT_FOR_APP_SELECTION',
    APPLICATION_SELECTED: 'APPLICATION_SELECTED',
    ASK_SIGNATURE: 'ASK_SIGNATURE',
    CHECK_SIGNATURE: 'CHECK_SIGNATURE',
    SIGNATURE_CHECKED: 'SIGNATURE_CHECKED',
    PIN_DIGIT_ENTERED: 'PIN_DIGIT_ENTERED',
    RECEIPT_PRINTED: 'RECEIPT_PRINTED',
    ASK_DCC: 'ASK_DCC',
    DCC_ACCEPTED: 'DCC_ACCEPTED',
    DCC_REJECTED: 'DCC_REJECTED',
    BALANCE_QUERY_STARTED: 'BALANCE_QUERY_STARTED',
    BALANCE_QUERY_COMPLETED: 'BALANCE_QUERY_COMPLETED',
    LOAD_STARTED: 'LOAD_STARTED',
    LOAD_COMPLETED: 'LOAD_COMPLETED',
    PROVIDE_CARD_DETAILS: 'PROVIDE_CARD_DETAILS',
    CARD_DETAILS_PROVIDED: 'CARD_DETAILS_PROVIDED',
    DIAGNOSIS: 'DIAGNOSIS',
    INITIATE_DIAGNOSIS: 'INITIATE_DIAGNOSIS'
} as const;
export type TerminalStateEventLatestEventCodeEnum = typeof TerminalStateEventLatestEventCodeEnum[keyof typeof TerminalStateEventLatestEventCodeEnum];


/**
 * Check if a given object implements the TerminalStateEvent interface.
 */
export function instanceOfTerminalStateEvent(value: object): value is TerminalStateEvent {
    if (!('askForTip' in value) || value['askForTip'] === undefined) return false;
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('pspTerminalId' in value) || value['pspTerminalId'] === undefined) return false;
    if (!('timestampMs' in value) || value['timestampMs'] === undefined) return false;
    return true;
}

export function TerminalStateEventFromJSON(json: any): TerminalStateEvent {
    return TerminalStateEventFromJSONTyped(json, false);
}

export function TerminalStateEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalStateEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'askForTip': json['askForTip'],
        'latestState': json['latestState'],
        'pspTerminalId': json['pspTerminalId'],
        'timestampMs': json['timestampMs'],
        'batteryLevel': json['batteryLevel'] === undefined ? undefined : json['batteryLevel'] === null ? null : json['batteryLevel'],
        'latestEventCode': json['latestEventCode'] === undefined ? undefined : json['latestEventCode'] === null ? null : json['latestEventCode'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'pspDetails': json['pspDetails'] === undefined ? undefined : json['pspDetails'] === null ? null : json['pspDetails'],
    };
}

export function TerminalStateEventToJSON(json: any): TerminalStateEvent {
    return TerminalStateEventToJSONTyped(json, false);
}

export function TerminalStateEventToJSONTyped(value?: TerminalStateEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'askForTip': value['askForTip'],
        'latestState': value['latestState'],
        'pspTerminalId': value['pspTerminalId'],
        'timestampMs': value['timestampMs'],
        'batteryLevel': value['batteryLevel'],
        'latestEventCode': value['latestEventCode'],
        'name': value['name'],
        'pspDetails': value['pspDetails'],
    };
}

